import { styleSizes } from 'constants/styleSizes';
import React from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import {
  BlogPostContainer,
  ContentContainer,
  ImageContainer,
} from './styles';

type BlogPostProps = {
  description: string;
  title: string;
  imageSource: string;
  imageWidth?: string;
  imageHeight?: string;
};

const BlogPost: React.FC<BlogPostProps> = ({
  description,
  title,
  imageSource,
  imageWidth,
  imageHeight,
}) => {
  useHistory()

  return (
    <BlogPostContainer>
      <ImageContainer imageWidth={imageWidth} imageHeight={imageHeight}>
        <source media={`(min-width:${styleSizes.miniBreakpoint})`} srcSet={imageSource} />
        <source media={`(max-width:${styleSizes.miniBreakpoint})`} srcSet={imageSource} />
        <img src={imageSource} alt="homeImage" />
      </ImageContainer>
      <ContentContainer>
        <div className="contentTitleContainer">
          {title}
        </div>
        <div className="contentDescriptionContainer">
          <p>{description}</p>
        </div>
        <Link to="/blog" className="link">
          Link text {'>'}
        </Link>
      </ContentContainer>

    </BlogPostContainer>
  )
}
export default BlogPost;
